var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4823_43159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 22.8352C11.7293 22.8352 12.4288 22.5455 12.9445 22.0298C13.4603 21.5141 13.75 20.8146 13.75 20.0852H8.25C8.25 20.8146 8.53973 21.5141 9.05546 22.0298C9.57118 22.5455 10.2707 22.8352 11 22.8352ZM12.3681 2.34637C12.3873 2.15518 12.3662 1.9621 12.3062 1.77956C12.2462 1.59703 12.1486 1.4291 12.0197 1.2866C11.8908 1.14411 11.7334 1.03022 11.5578 0.952267C11.3822 0.874318 11.1921 0.834045 11 0.834045C10.8079 0.834045 10.6178 0.874318 10.4422 0.952267C10.2666 1.03022 10.1092 1.14411 9.98033 1.2866C9.85142 1.4291 9.75381 1.59703 9.6938 1.77956C9.63378 1.9621 9.61268 2.15518 9.63188 2.34637C8.07774 2.66249 6.6806 3.50599 5.67705 4.73406C4.6735 5.96213 4.1252 7.49929 4.125 9.08525C4.125 10.595 3.4375 17.3352 1.375 18.7102H20.625C18.5625 17.3352 17.875 10.595 17.875 9.08525C17.875 5.75775 15.51 2.98025 12.3681 2.34637Z",
    fill: "#F8F9FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4823_43159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.834961)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlert);
export default __webpack_public_path__ + "static/media/ic_alert.3fa78ec717e670997eaecf5e75f337d2.svg";
export { ForwardRef as ReactComponent };